module.exports = {

  'Clicks' : 'Clicks',
  'Impressions' : 'Impressions',
  'Cost' : 'Cost',
  'Conversions' : 'Conversions',
  'ConversionValue' : 'Total conv. value',
  'HeadlinePart1' : 'Headline 1',
  'HeadlinePart2' : 'Headline 2',
  'HeadlinePart3' : 'Headline 3',
  'Description1' : 'Description line 1',
  'Description2' : 'Description line 2',
  'Description' : 'Description',
  'DisplayUrl' : 'Display URL',
  'Campaign' : 'CampaignName',
  'Ad group' : 'AdGroupName',
  'Search term' : 'Query',
  'CC': 'Conv. cost',
  'CR': 'Conv. rate',
  'ROAS': 'ROAS',
  'CTR': 'CTR',
  'CampaignName': "Campaign",
  'AdGroupName': "Ad group"

}


// WEBPACK FOOTER //
// ../i18n/en/table.js